import target from "./target"
import assign from "./assign"
import result from './result'
import enter2 from './enter2'
import enter1 from "./enter1"

export default {
    target ,
    assign ,
    result ,
    enter2 ,
    enter1
}